import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'compactCurrency'
})
export class CompactCurrencyPipe implements PipeTransform {

  transform(value: number, symbol: string = '₹'): string {
    if (value == null) return '';

    if (value >= 10000000) {
      return symbol + (value / 10000000).toFixed(1) + 'Cr';
    }

    if (value >= 100000) {
      return symbol + (value / 100000).toFixed(1) + 'L';
    }

    if (value >= 1000) {
      return symbol + (value / 1000).toFixed(1) + 'K';
    }

    return symbol + value;
  }

}
